import { FilterConfigDynamic } from '@/types/filter';
import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import { isNonEmptyString, isStringArray } from '@/api/queries/utils';
import { GetOptionsQueryFunction } from '@/types/cube';
import mapHierarchicalOptionsForIndicationMode from '@/models/filter/utils/mapHierarchicalOptionsForIndicationMode';
import expandHierarchicalPaths from '@/models/filter/utils/expandHierarchicalPaths';
import { getDeepestHierarchyLevel } from '@/models/filter/utils/hierarchyPath';
import parseHierarchicalFilterOldTree from '../../utils/parseHierarchicalFilterOldTree';

const dimensions = [
  `${CUBE_AGGREGATE_INTERACTION}.interaction_type_lvl_1`,
  `${CUBE_AGGREGATE_INTERACTION}.interaction_type_lvl_2`,
];
const OPTIONS: GetOptionsQueryFunction = ({}) => ({
  dimensions,
  limit: undefined,
});
const allInteractionTypeFilter: FilterConfigDynamic = {
  label: 'main.channelFocus.hcpCoverage.filters.interactionType.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.interactionType.placeholder',
  type: 'oldtreeselect',
  searchable: true,
  defaultValue: [],
  clearable: true,
  selectionMode: 'indication',
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  format: ({ value }) => {
    if (!isNonEmptyString(value)) return '';
    return getDeepestHierarchyLevel(value);
  },
  applyFilter: value => {
    if (!isStringArray(value)) return undefined;
    return parseHierarchicalFilterOldTree(value, dimensions);
  },
  mapResult: row => mapHierarchicalOptionsForIndicationMode(row, dimensions),
  processOptions: expandHierarchicalPaths,
  getOptionsQuery: OPTIONS,
};

export default allInteractionTypeFilter;
